module.exports = __webpack_public_path__ + "img/golem_factory_small.9ca3ee98.png";